var map = {
	"./small-form": "UG+M",
	"./small-form/": "UG+M",
	"./small-form/index": "UG+M",
	"./small-form/index.js": "UG+M",
	"./small-form/small-form-popup.module.scss": "ptyj"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Si0M";